import FiltersBar from "./FiltersBar";
export default FiltersBar;



// WEBPACK FOOTER //
// ./src/components/App/RouteTaskDashboard/FiltersBar/index.js